import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilterPrimary = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.89583 18V13.3125H10.1458V15.0417H17.5V16.2917H10.1458V18H8.89583ZM2.5 16.2917V15.0417H7.64583V16.2917H2.5ZM6.39583 12.8333V11.125H2.5V9.875H6.39583V8.125H7.64583V12.8333H6.39583ZM8.89583 11.125V9.875H17.5V11.125H8.89583ZM12.3542 7.6875V3H13.6042V4.70833H17.5V5.95833H13.6042V7.6875H12.3542ZM2.5 5.95833V4.70833H11.1042V5.95833H2.5Z",
		fill: "#118AB2"
	})
});
export default SvgFilterPrimary;
